export function getInitialUrl(repId: number | null, selectedTab?: string, entityId?: number): string {
	let initialUrl = `/AgentPortal/${repId}`;

	if (selectedTab) {
		initialUrl += `/${selectedTab}`;
		if (entityId) {
			initialUrl += `/${entityId}`;
		}
	}
	return initialUrl;
}

export function getInitialDialogSize(): { width: number; height: number } {
	if (typeof window === "undefined") return { width: 1600, height: 900 };

	const vw = window.innerWidth;
	const vh = window.innerHeight;

	return {
		width: Math.round(vw * 0.8),
		height: Math.round(vh * 0.8),
	};
}
